import { useTranslation } from "react-i18next";
import React, {useEffect, useState} from "react";
import useMobileAccess from "../../hooks/useMobileAccess";
import classResultClasses from "../JoinQuizPage/ClassResult.module.css";
import styles from "../JoinQuizPage/styles.module.css";
import classes from "../JoinQuizPage/ClassResult.module.css";
import {TEXTBOX} from "../../utils/constants";
import {LatexInline} from "../../components/Tiptap/latexParser";

export default function ViewLiveRespRK({question, chartData, isExpanded, notShowAnimation}) {
    const { t } = useTranslation();
    const {serialNo} = question;
    const [maxData, setMaxData] = useState(0);
    const [sortedKeys, setSortedKeys] = useState([]);
    const [sortedValues, setSortedValues ]  = useState([]);
    const [containerHeight, setContainerHeight] = useState(0);
    const isMobile = useMobileAccess(480);
    useEffect(() => {
        if (chartData && Object.keys(chartData).length > 0) {
            const sortedEntries= Object.entries(chartData)
                .sort(([, valueA], [, valueB]) => valueB - valueA);
            const newsortedKeys = [];
            const newsortedValues = [];
            for (const [key, value] of sortedEntries) {
                newsortedKeys.push(key);
                newsortedValues.push(value);
            }
            setSortedKeys(newsortedKeys);
            setSortedValues(newsortedValues);

            setMaxData(newsortedValues.length > 0 ? newsortedValues[0] : 0);
        } else {
            const newsortedKeys = [];
            const newsortedValues = [];
            for (let i = 0; i < question.optionsMap.length; i++) {
                newsortedKeys.push(question.optionsMap[i]);
                newsortedValues.push(question.optionsMap.length - i)
            }

            setSortedKeys(newsortedKeys);
            setSortedValues(newsortedValues);
            setMaxData(question.optionsMap.length);
        }

    }, [chartData]);

    const setBar = () => {
        sortedValues.forEach((entry, index) => {
            let bar = document.getElementById(`rk-${serialNo}-count-bar-${index}`);
            if (!!bar) {
                bar.style.width = `${!!maxData && maxData !== 0 ? (entry / maxData) * 100 : 0}%`;
            }
        });
    }

    const resetBar = () => {
        sortedValues.forEach((entry, index) => {
            let bar = document.getElementById(`rk-${serialNo}-count-bar-${index}`);
            if (!!bar) {
                bar.style.width = "0";
            }
        });
    }

    useEffect(() => {
        let height = 0;

        if (!!sortedKeys) {
            height = sortedKeys.length * 120;
        } else {
            height = 300;
        }

        setContainerHeight(height);
    }, [sortedKeys]);

    useEffect(() => {
        if (isExpanded) {
            setBar();
        } else {
            resetBar();
        }
    }, [isExpanded, sortedValues, maxData]);





    return (
        <div className={classResultClasses.chartContainer} style={{maxHeight: !isExpanded ? 0 : containerHeight}}>
            {JSON.stringify(setSortedValues)}
            <div className={classResultClasses.chartContainerBody}>
                {!!chartData &&
                    <div className={styles.chartContainer} style={{marginTop: 0}}>
                        {sortedKeys.map((entry, index) =>
                            <div key={index} className={classes.countBarContainer}
                                 style={{border: "none", boxShadow: "none"}}>
                                <div
                                    id={`rk-${serialNo}-count-bar-${index}`}
                                    className={classes.countBar}
                                    style={{transition: notShowAnimation ? "none" : undefined}}
                                />
                                <div className={classes.optionIndex} style={{width: 70}}> {t("poll.rankText")} {index + 1}</div>
                                <div id={`optionText${index}`} style={{position: "relative"}}>
                                    <LatexInline>{entry}</LatexInline>
                                </div>
                            </div>
                        )}

                    </div>
                }
            </div>
        </div>
    );
}